/**
 * Lightweight ABHA telemetry seam.
 *
 * No product-analytics vendor is wired into the app yet, so this emits a structured, NON-PII event
 * two ways: (1) a console breadcrumb (greppable in prod logs), and (2) a `abha:telemetry` window
 * CustomEvent that a real sink (GA / PostHog / a backend endpoint) can subscribe to LATER without
 * touching any call site. Keep payloads free of name/mobile/ABHA number — only counts + states.
 */
export function abhaTelemetry(event, props = {}) {
  const payload = {
    event,
    surface: 'appointment',
    ...props,
    ts: new Date().toISOString(),
  };
  try {
    if (process.env.NODE_ENV !== 'test') {
      // eslint-disable-next-line no-console
      console.info('[abha-telemetry]', JSON.stringify(payload));
    }
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('abha:telemetry', { detail: payload }));
    }
  } catch (_) { /* telemetry must never break the flow */ }
}
